<template>
  <div class="devicelog page-container">
    <div class="devicelog-m">
      <el-row>
        <el-col :span="24">
          <el-form
            :inline="true"
            :model="queryForm"
            @keyup.enter.native.prevent="fetchData"
            class="demo-form-inline toolbar"
            style="padding-bottom: 0px"
          >
            <!-- 表单内容保持不变 -->
            <el-form-item label="时间范围:">
              <el-date-picker
                :editable="false"
                v-model="queryForm.timevalue"
                unlink-panels
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :picker-options="pickerOptions"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="日志类型:">
              <el-select
                v-model="queryForm.logType"
                clearable
                placeholder="请选择日志类型"
                style="width:140px"
                filterable
              >
                <el-option
                  v-for="(item, index) in logTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="老人姓名:">
              <el-input
                v-model.trim="queryForm.oldmanName"
                placeholder="老人姓名"
                style="width:130px"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="设备编号:">
              <el-input
                v-model.trim="queryForm.deviceNo"
                placeholder="设备编号"
                style="width:130px"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-search"
                plain
                @click.native.prevent="fetchData"
              >查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="success"
                icon="el-icon-upload2"
                plain
                @click="toLead"
              >日志导入</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="success"
                icon="el-icon-upload2"
                plain
                @click="toLeadRoom"
              >呼叫导入</el-button>
            </el-form-item>
            <el-form-item>
              <el-button
                type="info"
                icon="el-icon-download"
                plain
                @click="exportLog"
              >导出</el-button>
            </el-form-item>
          </el-form>
        </el-col>

        <!-- 表格内容保持不变 -->
        <el-col v-loading="loading">
          <el-table
            :data="logList"
            style="width: 100%"
            :row-key="row => row.id"
            :header-cell-style="tableHeaderColor"
            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          >
            <el-table-column
              prop="deviceNo"
              label="设备编号"
              width="150"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              label="日志类型"
              min-width="100"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                {{ formatLogType(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="info"
              label="日志信息"
              align="center"
              min-width="170"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              label="老人姓名"
              align="center"
              min-width="80"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.oldmanName && scope.row.oldmanName !== ' '"
                >{{ scope.row.oldmanName }}</span>
                <span style="color: red" v-else>无</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="createdTime"
              label="记录时间"
              align="center"
              min-width="140"
              :show-overflow-tooltip="true"
            ></el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="totalDataNumber"
            layout="total, prev, pager, next"
            align="center"
            class="fenye"
          ></el-pagination>
        </el-col>
      </el-row>

      <!-- 日志数据导入弹窗 -->
      <el-dialog 
        title="日志数据导入" 
        width="30%" 
        :visible.sync="toLeadlogVisisble" 
        :close-on-click-modal="false"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input 
                  type="file" 
                  ref="logFile" 
                  id="logFile" 
                  @change="getLogUrl" 
                  accept=".xlsx,.xls"
                />
              </el-col>
            </el-row>
            <!-- 日志导入模板下载链接 -->
            <el-button  
              type="primary" 
              size="mini" 
              @click="downlogMoban" 
              style="margin-top: 40px;"
            >
              导入模版下载
            </el-button>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="toLeadlogVisisble = false">取消</el-button>
          <el-button type="primary" @click.native="intoLogForm">确定</el-button>
        </div>
      </el-dialog>

      <!-- 查房数据导入弹窗 -->
      <el-dialog 
        title="呼叫数据导入" 
        width="30%" 
        :visible.sync="toLeadCallVisisble" 
        :close-on-click-modal="false"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input 
                  type="file" 
                  ref="callFile" 
                  id="callFile" 
                  @change="getCallUrl" 
                  accept=".xlsx,.xls"
                />
              </el-col>
            </el-row>
            <!-- 查房导入模板下载链接 -->
            <el-button  
              type="primary" 
              size="mini" 
              @click="downCallMoban" 
              style="margin-top: 40px;"
            >
              导入模版下载
            </el-button>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="toLeadCallVisisble = false">取消</el-button>
          <el-button type="primary" @click.native="intoCallForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { baseURL } from "@/utils/request.js";

export default {
  name: 'DeviceLog',
  data() {
    return {
      queryForm: {
        timevalue: [],
        logType: "",
        oldmanName: "",
        deviceNo: ""
      },
      logTypeList: [
        { label: "上下线", value: "0" },
        { label: "事件", value: "1" },
        { label: "报警", value: "2" },
        { label: "其他", value: "3" }
      ],
      logList: [],
      totalDataNumber: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      // 导入相关变量
      toLeadlogVisisble: false,    // 日志导入弹窗控制
      toLeadCallVisisble: false,   // 查房导入弹窗控制
      logFormData: null,           // 日志导入表单数据
      callFormData: null,          // 查房导入表单数据
      logFileFlag: false,          // 日志文件选择标记
      callFileFlag: false          // 查房文件选择标记
    };
  },
  methods: {
    // 初始查询/重新查询
    fetchData() {
      this.pageNum = 1;
      this.getLogList();
    },

    // 获取日志列表数据
    getLogList() {
      const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.queryForm.deviceNo,
        oldmanName: this.queryForm.oldmanName,
        type: this.queryForm.logType ? Number(this.queryForm.logType) : ""
      };

      if (this.queryForm.timevalue && this.queryForm.timevalue.length === 2) {
        param.startTime = this.queryForm.timevalue[0];
        param.endTime = this.queryForm.timevalue[1].substring(0, 10) + " 23:59:59";
      }

      this.loading = true;
      this.$postJson("dmc/log/queryListWithPage", param)
        .then(res => {
          this.loading = false;
          if (res.result) {
            this.logList = res.result.list || [];
            this.totalDataNumber = Number(res.result.total) || 0;
          } else {
            this.logList = [];
            this.totalDataNumber = 0;
          }
        })
        .catch(error => {
          this.loading = false;
          this.logList = [];
          this.totalDataNumber = 0;
          console.error("获取日志列表失败：", error);
          this.$message.error("获取数据失败，请重试");
        });
    },

    // 分页相关方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.getLogList();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getLogList();
    },

    // 格式化日志类型
    formatLogType(type) {
      const typeMap = {
        0: "上下线",
        1: "事件",
        2: "报警",
        3: "其他"
      };
      return typeMap[type] || "未知类型";
    },

    // 表格头部样式
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },

    // 导出日志
    exportLog() {
      this.$confirm("确定要导出日志记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false
      }).then(() => {
        let urlParams = [];
        if (this.queryForm.logType) urlParams.push(`type=${this.queryForm.logType}`);
        if (this.queryForm.deviceNo) urlParams.push(`deviceNo=${this.queryForm.deviceNo}`);
        if (this.queryForm.oldmanName) urlParams.push(`oldmanName=${this.queryForm.oldmanName}`);
        
        if (this.queryForm.timevalue && this.queryForm.timevalue.length === 2) {
          const start = this.queryForm.timevalue[0].substring(0, 10) + " 00:00:00";
          const end = this.queryForm.timevalue[1].substring(0, 10) + " 23:59:59";
          urlParams.push(`startTime=${start}`);
          urlParams.push(`endTime=${end}`);
        }

        const fullUrl = `${baseURL}dmc/log/exportLog?groupId=${sessionStorage.getItem("groupId")}${
          urlParams.length ? "&" + urlParams.join("&") : ""
        }`;
        window.location.href = fullUrl;
      }).catch(() => {
        this.$message.info("已取消导出");
      });
    },
    toLeadRoom() { 
        this.toLeadCallVisisble = true;
        // 重置文件状态
        this.callFormData = null;
        this.callFileFlag = false;
        if (this.$refs.callFile) {
          this.$refs.callFile.value = ''; // 清空文件选择
        }
    },
    // 导入相关方法
    toLead() {
      // 打开日志导入弹窗（如果需要区分日志和查房导入，可以增加参数控制）
      this.toLeadlogVisisble = true;
      // 重置文件状态
      this.logFormData = null;
      this.logFileFlag = false;
      if (this.$refs.logFile) {
        this.$refs.logFile.value = ''; // 清空文件选择
      }
    },

    // 获取日志文件
    getLogUrl(event) {
      const file = event.target.files;
      if (file && file.length > 0) {
        this.logFileFlag = true;
        this.logFormData = new FormData();
        this.logFormData.append("file", file[0]);
        this.logFormData.append("groupId", sessionStorage.getItem("groupId"));
      }
    },

    // 获取查房文件
    getCallUrl(event) {
      const file = event.target.files;
      if (file && file.length > 0) {
        this.callFileFlag = true;
        this.callFormData = new FormData();
        this.callFormData.append("file", file[0]);
        this.callFormData.append("groupId", sessionStorage.getItem("groupId"));
      }
    },

    // 下载日志导入模板
    downlogMoban() {
      // 日志模板链接
      window.location.href = "https://cmny-test.oss-cn-hangzhou.aliyuncs.com/%E8%AE%BE%E5%A4%87%E6%97%A5%E5%BF%97%E8%A1%A8.xls";
    },

    // 下载查房导入模板
    downCallMoban() {
      // 查房模板链接
      window.location.href = "https://cmny-test.oss-cn-hangzhou.aliyuncs.com/find_room_list.xls";
    },

    // 提交日志导入
    intoLogForm() {
      if (!this.logFileFlag) {
        this.$message.error("请选择日志文件");
        return;
      }

      this.loading = true;
      this.$postFormData("dmc/ptPush/importCommonDeviceList", this.logFormData)
        .then(res => {
          this.loading = false;
          this.toLeadlogVisisble = false;
          this.logFileFlag = false;
          
          if (res.code === 200 || res.success) {
            this.$message.success("日志导入成功");
            this.fetchData(); // 刷新列表
          } else {
            this.$message.error(res.message || "日志导入失败");
          }
        })
        .catch(error => {
          this.loading = false;
          this.toLeadlogVisisble = false;
          this.logFileFlag = false;
          console.error("日志导入失败：", error);
          this.$message.error("导入失败，请检查文件格式");
        });
    },

    // 提交查房导入
    intoCallForm() {
      if (!this.callFileFlag) {
        this.$message.error("请选择查房文件");
        return;
      }

      this.loading = true;
      // 查房导入接口（根据实际接口调整）
      this.$postFormData("dmc/ptPush/importFindRoomDeviceList", this.callFormData)
        .then(res => {
          this.loading = false;
          this.toLeadCallVisisble = false;
          this.callFileFlag = false;
          
          if (res.code === 200 || res.success) {
            this.$message.success("查房数据导入成功");
            this.fetchData(); // 刷新列表
          } else {
            this.$message.error(res.message || "查房数据导入失败");
          }
        })
        .catch(error => {
          this.loading = false;
          this.toLeadCallVisisble = false;
          this.callFileFlag = false;
          console.error("查房数据导入失败：", error);
          this.$message.error("导入失败，请检查文件格式");
        });
    }
  },
  created() {
    this.getLogList();
  },
  beforeDestroy() {
    // 清理资源
  }
};
</script>

<style lang="scss" scoped>
.devicelog {
  .devicelog-m {
    padding: 10px 0 0 5px;
  }
}

::v-deep .el-form-item {
  margin-right: 10px;
  margin-bottom: 15px;
}

::v-deep .toolbar {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

::v-deep .el-table {
  margin-top: 10px;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

/* 导入弹窗样式 */
::v-deep .el-dialog__body {
  padding: 20px;
}

::v-deep #logFile, ::v-deep #callFile {
  width: 100%;
  padding: 8px;
  border: 1px dashed #ccc;
  border-radius: 4px;
  cursor: pointer;
}
</style>